if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const productUrl = opener.getAttribute('data-product-url');
        if (!productUrl) return;
        fetch(productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            const buyOptionsEl = responseHTML.querySelector('.buy-options-section:not(.buy-options-error)');
            const bundleBuilderEl = responseHTML.querySelector('.bundle-builder-container');
            const buySection = (buyOptionsEl && buyOptionsEl.closest('.shopify-section'))
              || (bundleBuilderEl && bundleBuilderEl.closest('.shopify-section'));

            const productUrl = productElement?.querySelector('.product__title a')?.getAttribute('href') || opener.getAttribute('data-product-url');
            const pathNav = document.createElement('div');
            pathNav.className = 'quick-add-customer-path';
            pathNav.innerHTML = `
              <div class="quick-add-customer-path__option">
                <span>New Customer?</span>
                <a href="${productUrl}">View Full Details <span class="quick-add-customer-path__arrow">&rarr;</span></a>
              </div>
              <div class="quick-add-customer-path__option">
                <span>Returning Customer?</span>
                <a href="#quick-add-buy-section" onclick="this.closest('.quick-add-modal__content-info').querySelector('.shopify-section')?.scrollIntoView({behavior:'smooth'});return false;">
                  Ready To Buy <span class="quick-add-customer-path__arrow">&darr;</span>
                </a>
              </div>
            `;

            if (productElement) {
              const priceContainer = productElement.querySelector('.no-js-hidden.price');
              if (priceContainer) {
                priceContainer.parentNode.insertBefore(pathNav, priceContainer.nextSibling);
              } else {
                const infoWrapper = productElement.querySelector('.product__info-wrapper');
                if (infoWrapper) infoWrapper.appendChild(pathNav);
                else productElement.appendChild(pathNav);
              }
            }

            if (buySection && productElement) {
              productElement.appendChild(buySection);
              if (!document.querySelector('link[href*="buy-options.css"]')) {
                const cssLink = responseHTML.querySelector('link[href*="buy-options.css"]');
                if (cssLink) document.head.appendChild(cssLink.cloneNode(true));
              }
            }

            const fallbackImageSrc = opener.getAttribute('data-product-featured-image')
              || responseHTML.querySelector('meta[property="og:image"]')?.getAttribute('content');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            this.ensureProductImage(fallbackImageSrc);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      ensureProductImage(fallbackSrc) {
        if (!fallbackSrc) return;
        const productDiv = this.modalContent.querySelector('.product');
        const mediaWrapper = this.modalContent.querySelector('.product__media-wrapper');
        if (!mediaWrapper) return;

        const visibleImg = mediaWrapper.querySelector('.product__media-item:first-child img');
        if (visibleImg) return;

        if (productDiv) {
          productDiv.classList.remove('product--no-media', 'grid--1-col');
          productDiv.classList.add('grid--2-col-tablet');
        }

        mediaWrapper.innerHTML = `
          <div class="product__media-item grid__item slider__slide is-active">
            <div class="media" style="position: relative; padding-bottom: 100%;">
              <img src="${fallbackSrc}" alt="" loading="eager" width="800" height="800"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain;">
            </div>
          </div>`;
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
